// uat
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { useSessionKey } from '../context/SessionKeyContext';

import { useBackground } from '../context/BackgroundContext';
// import loginBgDesktop from '../assets/login_page_4k.jpg';
// import loginBgMobile from '../assets/login_phone.jpg'; 
import loginBgDesktop from '../assets/login_page_4k_latest.jpg';
import loginBgMobile from '../assets/login_phone_long.jpg'; 
import './LoginPage.css';
import { encryptAES, decryptAES } from "../utils/cryptoUtils";
import { fetchInitialJwt, createApiClient } from '../utils/api';


const AgentPass = () => {
  const [empId, setEmpId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  

  const { setKey, sessionKey, loadingKey } = useSessionKey();
  const navigate = useNavigate();
  const { changeBackground } = useBackground();

  useEffect(() => {
    changeBackground(loginBgDesktop);
  }, [changeBackground]);

  useEffect(() => {
    if (!loadingKey && sessionKey) {
      navigate('/user-details');
    }
  }, [sessionKey, loadingKey, navigate]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
  changeBackground(isMobile ? loginBgMobile : loginBgDesktop);
}, [changeBackground, isMobile]);


  const unwrap = (p) => JSON.parse(decryptAES(p.encryptedResponse));

  const handleAgentPass = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

  if (!empId.trim()) {
    setError("Please enter your Employee ID.");
    setLoading(false);
    return;
  }
  

    try {
            const initialToken = await fetchInitialJwt();
            const tempApiClient = createApiClient(initialToken);
            const payload = {
              step : "agent_pass",
              emp_id: empId,
            };
      
            const encryptedPayload = encryptAES(
              JSON.stringify(payload)
            );

            // uat
            // const response = await tempApiClient.post(
            //   "https://api-uat.iciciprulife.com/biu/aspireai/otp/request",
            //   { encryptedRequest: encryptedPayload }
            // );

            // prod
            const response = await tempApiClient.post(
              "https://api.iciciprulife.com/biu/aspireai/otp/request",
              { encryptedRequest: encryptedPayload }
            );
            
            const data = await response.json(); 
            const result = unwrap(data);
      
            if (result.error) {
              setError(result.error);
            } else {
              alert("Verification Successful!");
          
              // Store emp_id for next step
              sessionStorage.setItem("emp_id", empId);
          
              // Navigate to OTP page (next page)
              navigate("/login");
            }
          } catch (err) {
            console.error("Agent pass error:", err);
            setError("Network error. Please try again.");
          } finally {
            setLoading(false);
          }
        };
      
      


        return (
          <Layout>
              <div className="login-container">
                  <div className="login-card">
                      <h2>Login</h2>
                      {error && <p className="error-message">{error}</p>}

                      <form onSubmit={handleAgentPass}>
                        <div className="form-group">
                          <label>Employee ID</label>
                          <input
                            type="text"
                            value={empId}
                            onChange={(e) => setEmpId(e.target.value)}
                            placeholder="Enter Emp ID "
                            required
                          />
                        </div>

                        <button type="submit" disabled={loading}>
                          {loading ? "Verifying..." : "Continue"}
                        </button>
                      </form>
                      </div>
                      </div>
                      </Layout>
                            );
                          };
    
export default AgentPass;

// Local Testing
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Layout from "./Layout";
// import { useBackground } from "../context/BackgroundContext";
// import loginBgDesktop from '../assets/login_page_4k_latest.jpg';
// import loginBgMobile from '../assets/login_phone_long.jpg'; 
// import "./LoginPage.css";
// const AgentPass = () => {
// const [empId, setEmpId] = useState("");
// const [loading, setLoading] = useState(false);
// const [error, setError] = useState("");
// const navigate = useNavigate();
// const { changeBackground } = useBackground();
// const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
// useEffect(() => {
// const handleResize = () => {
// setIsMobile(window.innerWidth <= 600);
// };

//   window.addEventListener("resize", handleResize);
//   return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//   changeBackground(isMobile ? loginBgMobile : loginBgDesktop);
// }, [changeBackground, isMobile]);

//     const handleAgentPass = async (e) => {
//         e.preventDefault();
//         setError("");
//         setLoading(true);

//       if (!empId.trim()) {
//         setError("Please enter your Employee ID.");
//         setLoading(false);
//         return;
//       }
      
//       try {
//         const response = await fetch(
//           "http://127.0.0.1:8028/aspireai/otp_request",
//           {
//             method: "POST",
//             credentials: "include",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               step: "agent_pass",
//               emp_id: empId,
//             }),
//           }
//         );
      
//         const data = await response.json();
      
//         if (data.error) {
//           setError(data.error);
//         } else {
//           alert("Verification successful");
      
//           // Store emp_id for next step
//           sessionStorage.setItem("emp_id", empId);
      
//           // Navigate to OTP page (next page)
//           navigate("/login");
//         }
//       } catch (err) {
//         console.error("Agent pass error:", err);
//         setError("Network error. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
      
//   return (
//           <Layout>
//               <div className="login-container">
//                   <div className="login-card">
//                       <h2>Login</h2>
//                       {error && <p className="error-message">{error}</p>}

// <form onSubmit={handleAgentPass}>
//   <div className="form-group">
//     <label>Employee ID</label>
//     <input
//       type="text"
//       value={empId}
//       onChange={(e) => setEmpId(e.target.value)}
//       placeholder="Enter Emp ID "
//       required
//     />
//   </div>

//   <button type="submit" disabled={loading}>
//     {loading ? "Verifying..." : "Continue"}
//   </button>
// </form>
// </div>
// </div>
// </Layout>
//       );
//     };
    
//     export default AgentPass;

 